import React from "react";
import { connect } from "react-redux";
import { Popup, ScrollView } from "devextreme-react";
import Form from "../Form";
import List from "../List";

function LotDataEntryListingPopup(props) {
    return (<>
        {props.showPopup.visible == true && (
            <Popup
                visible={props.showPopup.visible}
                onHiding={() => props.setShowPopup(prevFormData => ({ ...prevFormData, visible: false }))}
                dragEnabled={false}
                hideOnOutsideClick={true}
                showCloseButton={true}
                showTitle={true}
                title={props.showPopup.title}
                container="#root"
                width="100vw"
                height="100vh"
            >
                    {props.showPopup.visible == true && (<List setSelectedRow={props.setSelectedRow} toolbarItems={props.toolbarItems} module={props.showPopup.module} rIdentity = {props.showPopup.rIdentity} Available={props.showPopup.available}/>)}
            </Popup>
        )}
    </>

    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(LotDataEntryListingPopup);
